var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg043LandDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "65px",
    viewBox: "0 0 70 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "043-land") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-6.4%",
    y: "-23.5%",
    width: "112.8%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0396941925 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JetOS-v3-/-Lightmode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JetOS-Light/v3/01.1-Dashboard-new",
    transform: "translate(-1142.000000, -276.000000)",
    fill: "#AEE6F7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTENT",
    transform: "translate(375.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Number",
    transform: "translate(1.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    filter: "url(#filter-1)",
    transform: "translate(763.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "043-land",
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5928091,19.0725644 C30.4245199,16.686237 27.6189206,15.0365007 24.4794787,14.3015971 L20.3998918,13.3466161 L13.2369721,2.18820292 C13.0897759,1.95890072 12.8590692,1.79593321 12.5937556,1.73384517 L7.73862455,0.597388301 C7.52839911,0.156137717 7.04108428,-0.0812204484 6.56405954,0.0252887435 C6.08703479,0.131797935 5.74696162,0.553893746 5.74438808,1.04265769 C5.74181454,1.53142163 6.07742397,1.95707518 6.55330067,2.06860179 L10.8602774,11.1137804 L7.55250803,10.3395019 L4.7693383,5.86159603 C4.47536279,5.38860553 3.86287279,5.2282233 3.37483548,5.49597234 L0.544064356,7.04952147 C0.114818646,7.28508731 -0.0941804731,7.78642249 0.0406286572,8.25713433 L2.21341776,15.8403103 C2.31807311,16.2055504 2.61219729,16.4855508 2.98214157,16.5721202 L30.3025985,22.9670895 C30.4918791,23.0113159 30.6803159,23.0328315 30.8653777,23.0328315 C31.6883123,23.0328315 32.4433955,22.6072314 32.8811596,21.8626247 C33.4175014,20.9506749 33.3042987,19.8554913 32.5928091,19.0725644 L32.5928091,19.0725644 Z M31.0742051,20.8001363 C31.0074788,20.9136906 30.9088307,20.9559483 30.7805109,20.9259249 L4.05932522,14.6712286 L2.28661281,8.48452414 L3.51306936,7.81156561 L6.00106827,11.8145825 C6.14771011,12.0504747 6.38194397,12.2185576 6.65237063,12.2819481 L12.5048106,13.6518416 C12.7150329,14.0931078 13.2023618,14.3304748 13.6793976,14.2239568 C14.1564333,14.1174387 14.4965047,13.6953202 14.4990562,13.2065434 C14.5016077,12.7177666 14.1659619,12.2921207 13.6900642,12.1806281 L9.38315773,3.13537922 L11.7022666,3.67826009 L18.8651863,14.8367436 C19.0123825,15.0660458 19.2430892,15.2290133 19.5084028,15.2911014 L24.001707,16.342832 C26.7256035,16.9804937 29.1598838,18.4118402 31.041299,20.4823953 C31.1298924,20.5797777 31.1409314,20.6867227 31.0742051,20.8001363 L31.0742051,20.8001363 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.951785,28.1997974 L17.9444474,28.1997974 C17.3655667,28.1997974 16.8963027,28.6691316 16.8963027,29.247942 C16.8963027,29.8267525 17.3655667,30.2960867 17.9444474,30.2960867 L34.9518553,30.2960867 C35.5307361,30.2960867 36,29.8268228 36,29.247942 C36,28.6690613 35.5307361,28.1997974 34.951785,28.1997974 L34.951785,28.1997974 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2096206,20.017561 C12.6613257,20.017561 12.1360932,20.4996218 12.1614759,21.0657057 C12.1869289,21.6336177 12.6220211,22.1138504 13.2096206,22.1138504 C13.7579155,22.1138504 14.283148,21.6317896 14.2577653,21.0657057 C14.2323826,20.4977937 13.7972904,20.017561 13.2096206,20.017561 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8432873,20.7961285 C16.2949924,20.7961285 15.7697599,21.2781893 15.7951426,21.8442732 C15.8205956,22.4121853 16.2556878,22.8924179 16.8432873,22.8924179 C17.3916525,22.8924179 17.9168147,22.4103571 17.891432,21.8442732 C17.8660493,21.2764315 17.4308867,20.7961285 16.8432873,20.7961285 Z",
    id: "Path"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg043LandDashboard);
export default __webpack_public_path__ + "static/media/043-land-dashboard.29c66e40.svg";
export { ForwardRef as ReactComponent };